package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.info.InfoPageScaffold
import com.arena_web.ui.sections.info.InfoParagraph
import com.arena_web.ui.sections.info.InfoSection
import com.arena_web.ui.theme.AppTypography
import com.arena_web.ui.utils.Constants
import com.arena_web.ui.utils.isMobile
import com.arena_web.ui.utils.mFontSize
import com.arena_web.ui.utils.mLetterSpacing
import com.arena_web.ui.utils.mLineHeight
import com.arena_web.ui.utils.sFontSize
import com.arena_web.ui.utils.sLetterSpacing
import com.arena_web.ui.utils.sLineHeight
import com.arena_web.ui.components.StoreDownloadLinks
import com.arena_web.ui.components.navigation.NavAnchor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText

@Page("/about")
@Composable
fun AboutPage() {
    val ctx = rememberPageContext()
    PageLayout(
        title = "About",
        description = Constants.PRODUCT_DEFINITION,
        mobileReady = true,
    ) {
        InfoPageScaffold(title = "What is Arena Pro Play?", titleIsH1 = true) {
            AboutLead("Find your players, your team, and your game.")

            InfoParagraph(Constants.PRODUCT_DEFINITION)

            InfoParagraph(
                "Arena Pro Play helps you find people nearby who love the same sport and " +
                    "want to play. Instead of scrolling through group chats and messaging " +
                    "strangers, you find like-minded players, join a game, or create your " +
                    "own — all in one place."
            )

            InfoSection("Find players & connect") {
                InfoParagraph(
                    "Arena Pro Play is a social network built around sport. Create a profile, " +
                        "follow other athletes, chat, and track your stats. Find like-minded " +
                        "people at your level and in your city."
                )
            }

            InfoSection("Join or create events") {
                InfoParagraph(
                    "Discover games and events happening near you and join with one tap, or " +
                        "create your own event and invite other players to fill the roster."
                )
            }

            InfoSection("Discover and book clubs") {
                InfoParagraph(
                    "Browse real sports venues and clubs, see where people play, and book a " +
                        "place to play — from football pitches to tennis, basketball, padel " +
                        "and volleyball courts."
                )
            }

            InfoSection("Follow sports news") {
                InfoParagraph(
                    "Keep up with the latest sports news across all the games you care about, " +
                        "right inside Arena Pro Play."
                )
            }

            InfoSection("Track your progress") {
                InfoParagraph(
                    "Build your player profile and track your sports activity over time as you " +
                        "play more games and meet more people."
                )
            }

            InfoSection("Sports on Arena Pro Play") {
                InfoParagraph(
                    "Football, tennis, basketball, padel and volleyball — with more ways to " +
                        "play being added across cities in Europe and beyond."
                )
                NavAnchor("/sports", onNavigate = { ctx.router.navigateTo("/sports") }) {
                    InfoParagraph("Browse all sports and find players →")
                }
                NavAnchor("/cities", onNavigate = { ctx.router.navigateTo("/cities") }) {
                    InfoParagraph("Find players and clubs by city →")
                }
            }

            InfoSection("Get the app") {
                InfoParagraph(
                    "Arena Pro Play is available on iOS and Android. Download the app to find " +
                        "players and games near you:"
                )
                StoreDownloadLinks()
            }

            AboutLead("Your vibe and your crew. Your perfect game starts here.")
        }
    }
}

@Composable
private fun AboutLead(text: String) {
    if (isMobile()) {
        SpanText(
            text,
            modifier = Modifier
                .mFontSize(26)
                .mLineHeight(30)
                .mLetterSpacing(1)
                .fontWeight(AppTypography.SemiBold)
                .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
                .styleModifier { property("color", "#FFFFFF") }
        )
        return
    }
    SpanText(
        text,
        modifier = Modifier
            .sFontSize(26)
            .sLineHeight(34)
            .sLetterSpacing(0.4)
            .fontWeight(AppTypography.SemiBold)
            .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
            .styleModifier { property("color", "#FFFFFF") }
    )
}
